export { Card } from "./card-component";
export type { CardProps } from "./card-component";
